import { useState } from "react";
import { Button, Col, Row, Space, Typography } from "antd";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import AdminsView from "../components/AdminsView";
import AdminFormDialog from "../components/AdminFormDialog";
import { AdminForm } from "../components/AdminFormDialog.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

function AdminsPage() {
  const permissions = useSelector(authorizeSelectors.permissions);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const [, setSearchQuery] = useState<SearchQuery>({ conditions: [] });
  const [adminInputMode, setAdminInputMode] = useState<
    "add" | "update" | "delete"
  >("add");
  const [adminInputValues, setAdminInputValues] = useState<AdminForm>(
    {} as any,
  );
  const [adminInputOpen, setAdminInputOpen] = useState(false);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onAdminInputOpen(
    mode: "add" | "update" | "delete",
    values?: any,
  ): void {
    setAdminInputMode(mode);
    setAdminInputOpen(true);
    setAdminInputValues(
      values
        ? {
            uid: values.uid,
            identifier: values.userName,
            firstName: values.firstName,
            middleName: values.middleName,
            lastName: values.lastName,
            email: values.email,
            phoneNumber: values.phoneNumber,
          }
        : ({} as any),
    );
  }

  function onAdminFinish(): void {
    setAdminInputOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onAdminClose(): void {
    setAdminInputOpen(false);
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Admins
        </Typography.Title>
        <Space className="flex flex-row">
          <Button
            type="primary"
            disabled={!permissions.can("PlatformUsers", "create")}
            onClick={() => onAdminInputOpen("add")}
          >
            Add Admin
          </Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <AdminsView
          trigger={triggerView}
          onSearch={onSearch}
          onAction={(key: string, record: any) =>
            onAdminInputOpen(key as any, record)
          }
        />
      </Col>
      <AdminFormDialog
        open={adminInputOpen}
        mode={adminInputMode}
        initialValues={adminInputValues}
        onFinish={onAdminFinish}
        onCancel={onAdminClose}
      />
    </Col>
  );
}

export default AdminsPage;
